import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { store } from "./store";

import { Chart, registerables } from "chart.js";
import { Toaster } from "sonner";

Chart.register(...registerables);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Toaster richColors />
      <App />
    </Provider>
  </React.StrictMode>,
);

serviceWorkerRegistration.unregister();

reportWebVitals();
